console.log("custom js file loaded")